<div
  class="contextmenu mat-elevation-z4"
  [ngStyle]="{ 'left.px': x, 'top.px': y, 'height.px': height }">
  <coin-v2-text-input
    matFormFieldClass="shadow"
    [placeholder]="'general.enter-text' | translate"
    [label]="'general.search' | translate"
    [(ngModel)]="search" />
  <div class="items">
    @for (item of filteredMenuReplacements; track item) {
      <p
        class="context-menu-item"
        (click)="addItem(item)">
        {{ item.value }}
      </p>
    }
  </div>
</div>
